import Icon, { IconName } from '@features/ui-atoms/components/Icon';
import Tooltip from '@features/ui-atoms/components/Tooltip';
import { formatDateDashed } from '@root/src/utils/formatters/dates';
import { styled } from '@mui/joy';
import { useTranslation } from 'next-i18next';

type VerifiedMemberBadgeProps = {
  variant?: 'default' | 'white';
  memberSince?: Date;
};

export const VerifiedMemberBadge = ({ variant = 'default', memberSince }: VerifiedMemberBadgeProps) => {
  const { t } = useTranslation('common');
  const tooltip = memberSince
    ? `${t('member.verifiedBadge')} — ${t('member.memberSince')}: ${formatDateDashed(memberSince)}`
    : t('member.verifiedBadge');

  return (
    <Tooltip title={tooltip}>
      <BadgeIcon variant={variant}>
        <Icon name={IconName.verified} size={18} />
      </BadgeIcon>
    </Tooltip>
  );
};

const BadgeIcon = styled('div')<{ variant: 'default' | 'white' }>(({ theme: { palette }, variant }) => ({
  display: 'flex',
  alignItems: 'center',
  color: variant === 'white' ? palette.white : palette.bluePrimary,
  cursor: 'default',
}));
